@if (form && formService) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <ndt-dialog [titleText]="name" id="nameFieldHiddenOverflow" [isLoading]="loading">
      <div dialog-content>
        <ndt-tile-layout-configurations
          [formService]="formService"
          [tileConfig]="tileConfig"
          (tileSetTypeChange)="onTileSetTypeChange($event)"
        ></ndt-tile-layout-configurations>
        <ndt-report-parameters-list [formService]="formService"></ndt-report-parameters-list>
      </div>
    </ndt-dialog>
    <mat-dialog-actions style="display: flex; justify-content: flex-end; width: 100%; padding-right: 1.5em">
      <button type="submit" mat-raised-button class="paramter-tile-button" color="primary" style="margin-left: auto"
        >Save Tile</button
        >
      </mat-dialog-actions>
    </form>
  }
